/** postMessage types from document host pages when OpenAsync fails. */
export const RICH_EDIT_OPEN_FAILED = 'jarvis-richedit:open-failed';
export const SPREADSHEET_OPEN_FAILED = 'jarvis-spreadsheet:open-failed';

export type DocumentHostOpenFailedMessage = {
  type: typeof RICH_EDIT_OPEN_FAILED | typeof SPREADSHEET_OPEN_FAILED;
  message?: string | null;
};

export function isDocumentHostOpenFailedMessage(data: unknown): data is DocumentHostOpenFailedMessage {
  if (!data || typeof data !== 'object' || !('type' in data)) return false;
  const type = (data as { type?: unknown }).type;
  return type === RICH_EDIT_OPEN_FAILED || type === SPREADSHEET_OPEN_FAILED;
}

/** Safety net when the host never posts ready or open-failed. */
export const DOCUMENT_HOST_OPEN_TIMEOUT_MS = 15_000;
